/**
 * Datadog reporter for performance tools. Do not use on its own, use it with the
 * core utils in `./core`.
 *
 * @see ../client.ts for more information on how to use this.
 */
import {telemetry} from '@packages/systems/designer-telemetry';
import {Reporter} from '../types';

export const datadogReporter: Reporter = {
  report(eventName, eventData) {
    telemetry.sendEvent(`datadog::${eventName}`, eventData);
  },
};
